import 'jquery';
import Router from './util/Router';
import common from './routes/common';
import templateGlobalRates from './routes/templateGlobalRates';

/**
 * Populate Router instance with DOM routes
 *
 * To construct a route, use a class from <body> tag. Eg: template-global-homepage >> templateGlobalHomepage
 *
 **/
const routes = new Router({
  // All pages
  common,

  // Global Rates
  templateGlobalRates,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Force CSS update
if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    const reporter = window.__webpack_hot_middleware_reporter__;
    const success = reporter.success;
    reporter.success = function() {
      document.querySelectorAll('[id*="sage"]').forEach((link) => {
        link.href = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      });
      success();
    };
  }
}



// WEBPACK FOOTER //
// ./scripts/main.js